import { PaymentSavedReportsApi, RateProgramDropdownApi, StaffNotificationApi, SubscriptionSavedReportsApi } from "./ApiTransport"; 
import { OperatorApi } from "./ApiTransport"; 
import { FacilityInfoApi } from "./ApiTransport"; 
import { UsAddressApi } from "./ApiTransport"; 
import { CoordinatesApi } from "./ApiTransport"; 
import { OrderDebtApi } from "./ApiTransport"; 
import { VehicleApi } from "./ApiTransport"; 
import { RateProgramApi } from "./ApiTransport"; 
import { RateEntryApi } from "./ApiTransport"; 
import { FacilityImageApi } from "./ApiTransport"; 
import { ListedPlanApi } from "./ApiTransport"; 
import { OrderApi } from "./ApiTransport"; 
import { OrderDetailsApi } from "./ApiTransport"; 
import { OrderBalanceApi } from "./ApiTransport"; 
import { InvoiceApi } from "./ApiTransport"; 
import { PaymentApi } from "./ApiTransport"; 
import { ApplyPaymentApi } from "./ApiTransport"; 
import { OrderInfoApi } from "./ApiTransport"; 
import { PaymentChangeApi } from "./ApiTransport"; 
import { LogInReqApi } from "./ApiTransport"; 
import { ChangeNameReqApi } from "./ApiTransport"; 
import { ChangePhoneReqApi } from "./ApiTransport"; 
import { StripeLinkRespApi } from "./ApiTransport"; 
import { ChangePasswordReqApi } from "./ApiTransport"; 
import { ForgotPasswordReqApi } from "./ApiTransport"; 
import { StaffApi } from "./ApiTransport"; 
import { StaffUpdateReqApi } from "./ApiTransport"; 
import { InviteStaffReqApi } from "./ApiTransport"; 
import { SearchResultApi } from "./ApiTransport"; 
import { PlanCreateReqApi } from "./ApiTransport"; 
import { PlanUpdateReqApi } from "./ApiTransport"; 
import { PlanPriceAddReqApi } from "./ApiTransport"; 
import { PlanPriceListRespApi } from "./ApiTransport"; 
import { ReservationApi } from "./ApiTransport"; 
import { SubscriptionApi } from "./ApiTransport"; 
import { PlanInfoApi } from "./ApiTransport"; 
import { FacilityApi, FacilityLiteApi } from "./ApiTransport"; 
import { ParkerApi } from "./ApiTransport"; 
import { ParkerListEntryApi } from "./ApiTransport"; 
import { ParkerDetailsApi } from "./ApiTransport"; 
import { ParkerDetailsGridResultApi } from "./ApiTransport"; 
import { ParkerDetailsGridApi } from "./ApiTransport"; 
import { CheckCreateReqApi } from "./ApiTransport"; 
import { PmtApplyApi } from "./ApiTransport"; 
import { PlanApi } from "./ApiTransport"; 
import { PlanDetailsApi } from "./ApiTransport"; 
import { PlanChangeApi } from "./ApiTransport"; 
import { PlanPriceInfoApi } from "./ApiTransport"; 
import { PlanPriceDetailsApi } from "./ApiTransport"; 
import { InviteParkerReqApi } from "./ApiTransport"; 
import { FacilityCreateReqApi } from "./ApiTransport"; 
import { FacilityUpdateReqApi } from "./ApiTransport"; 
import { ParkerAgingRecordApi } from "./ApiTransport"; 
import { ParkerInfoApi } from "./ApiTransport"; 
import { RateProgramDataApi } from "./ApiTransport"; 
import { RateProgramInfoApi } from "./ApiTransport"; 
import { RateEntryDataApi } from "./ApiTransport"; 
import { SubscriberInfoApi } from "./ApiTransport"; 
import { SubscriptionUpdateReqApi } from "./ApiTransport"; 
import { SubEntryApi } from "./ApiTransport"; 
import { SubEntryForEditApi } from "./ApiTransport"; 
import { AccessPeriodInfoApi } from "./ApiTransport"; 
import { SubscriptionParkerApi } from "./ApiTransport"; 
import { ParkerUpdateReqApi } from "./ApiTransport"; 
import { SubListEntryApi } from "./ApiTransport"; 
import { PlanInfoBasicApi } from "./ApiTransport"; 
import { FacilitySubApi } from "./ApiTransport"; 
import { DeleteConfirmApi } from "./ApiTransport"; 
import { ChangeEmailReqApi } from "./ApiTransport"; 
import { VehicleDetailsApi } from "./ApiTransport"; 
import { VehicleLinkApi } from "./ApiTransport"; 
import { FacilityInvoiceApi } from "./ApiTransport"; 
import { ResetCodeCheckReqApi } from "./ApiTransport"; 
import { ResetPasswordReqApi } from "./ApiTransport"; 
import { AccessKeyApi } from "./ApiTransport"; 
import { AccessKeyListEntryApi } from "./ApiTransport"; 
import { AccessKeyLinkInfoApi } from "./ApiTransport"; 
import { SubscriptionInfoApi } from "./ApiTransport"; 
import { AccessKeyReqApi } from "./ApiTransport"; 
import { AccessKeyAssignSubApi } from "./ApiTransport"; 
import { AccessKeyParkerAssignReqApi } from "./ApiTransport"; 
import { AccessKeyVehicleSubAssignReqApi } from "./ApiTransport"; 
import { SubscriptionParkerAccessKeyApi } from "./ApiTransport"; 
import { SubscriptionParkerVehicleAccessKeyApi } from "./ApiTransport"; 
import { FacilityStatsApi } from "./ApiTransport"; 
import { SubscriptionStatApi } from "./ApiTransport"; 
import { ReservationStatApi } from "./ApiTransport"; 
import { OrderStatApi } from "./ApiTransport"; 
import { ParkerSubInfoApi } from "./ApiTransport"; 
import { FacilityPaymentApi } from "./ApiTransport"; 
import { BalanceChangeApi } from "./ApiTransport"; 
import { ImportPaymentReqApi } from "./ApiTransport"; 
import { SessionApi } from "./ApiTransport"; 
import { SessionSubscriptionApi } from "./ApiTransport"; 
import { SessionAccessPeriodApi } from "./ApiTransport"; 
import { PlanInvoiceReqApi } from "./ApiTransport"; 
import { PlanInvoiceRespApi } from "./ApiTransport"; 
import { InvoiceInfoApi } from "./ApiTransport"; 
import { InvoiceArgsApi } from "./ApiTransport"; 
import { SubscriptionParkerInviteReqApi } from "./ApiTransport"; 
import { SubscriptionParkerChangeReqApi } from "./ApiTransport"; 
import { SubscriptionParkerRemoveReqApi } from "./ApiTransport"; 
import { VehicleAddReqApi } from "./ApiTransport"; 
import { VehicleDeleteReqApi } from "./ApiTransport"; 
import { VehicleLinkRespApi } from "./ApiTransport"; 
import { OrderCustomReqApi } from "./ApiTransport"; 
import { OrderCustomItemReqApi } from "./ApiTransport"; 
import { FacilityPayoutApi } from "./ApiTransport"; 
import { PayoutTransactionApi } from "./ApiTransport"; 
import { PayoutTransactionPaymentApi } from "./ApiTransport"; 
import { OrderAdjustReqApi } from "./ApiTransport"; 
import { PaymentAdjustReqApi } from "./ApiTransport"; 
import { PlanBillInitRespApi } from "./ApiTransport"; 
import { PlanBillConfirmRespApi } from "./ApiTransport"; import { FacilitySubByParker, Operator, PaymentSavedReports, RateProgramDropdown, StaffNotification, SubscriptionSavedReports } from "./ApiTypes";
import { FacilityInfo } from "./ApiTypes"; 
import { UsAddress } from "./ApiTypes"; 
import { Coordinates } from "./ApiTypes"; 
import { OrderDebt } from "./ApiTypes"; 
import { Vehicle } from "./ApiTypes"; 
import { RateProgram } from "./ApiTypes"; 
import { RateEntry } from "./ApiTypes"; 
import { FacilityImage } from "./ApiTypes"; 
import { ListedPlan } from "./ApiTypes"; 
import { Order } from "./ApiTypes"; 
import { OrderDetails } from "./ApiTypes"; 
import { OrderBalance } from "./ApiTypes"; 
import { Invoice } from "./ApiTypes"; 
import { Payment } from "./ApiTypes"; 
import { ApplyPayment } from "./ApiTypes"; 
import { OrderInfo } from "./ApiTypes"; 
import { PaymentChange } from "./ApiTypes"; 
import { LogInReq } from "./ApiTypes"; 
import { ChangeNameReq } from "./ApiTypes"; 
import { ChangePhoneReq } from "./ApiTypes"; 
import { StripeLinkResp } from "./ApiTypes"; 
import { ChangePasswordReq } from "./ApiTypes"; 
import { ForgotPasswordReq } from "./ApiTypes"; 
import { Staff } from "./ApiTypes"; 
import { StaffUpdateReq } from "./ApiTypes"; 
import { InviteStaffReq } from "./ApiTypes"; 
import { SearchResult } from "./ApiTypes"; 
import { PlanCreateReq } from "./ApiTypes"; 
import { PlanUpdateReq } from "./ApiTypes"; 
import { PlanPriceAddReq } from "./ApiTypes"; 
import { PlanPriceListResp } from "./ApiTypes"; 
import { Reservation } from "./ApiTypes"; 
import { Subscription } from "./ApiTypes"; 
import { PlanInfo } from "./ApiTypes"; 
import { Facility } from "./ApiTypes"; 
import { Parker } from "./ApiTypes"; 
import { ParkerListEntry } from "./ApiTypes"; 
import { ParkerDetails } from "./ApiTypes"; 
import { ParkerDetailsGridResult } from "./ApiTypes"; 
import { ParkerDetailsGrid } from "./ApiTypes"; 
import { CheckCreateReq } from "./ApiTypes"; 
import { PmtApply } from "./ApiTypes"; 
import { Plan } from "./ApiTypes"; 
import { PlanDetails } from "./ApiTypes"; 
import { PlanChange } from "./ApiTypes"; 
import { PlanPriceInfo } from "./ApiTypes"; 
import { PlanPriceDetails } from "./ApiTypes"; 
import { InviteParkerReq } from "./ApiTypes"; 
import { FacilityCreateReq } from "./ApiTypes"; 
import { FacilityUpdateReq } from "./ApiTypes"; 
import { ParkerAgingRecord } from "./ApiTypes"; 
import { ParkerInfo } from "./ApiTypes"; 
import { RateProgramData } from "./ApiTypes"; 
import { RateProgramInfo } from "./ApiTypes"; 
import { RateEntryData } from "./ApiTypes"; 
import { SubscriberInfo } from "./ApiTypes"; 
import { SubscriptionUpdateReq } from "./ApiTypes"; 
import { SubEntry } from "./ApiTypes"; 
import { SubEntryForEdit } from "./ApiTypes"; 
import { AccessPeriodInfo } from "./ApiTypes"; 
import { SubscriptionParker } from "./ApiTypes"; 
import { ParkerUpdateReq } from "./ApiTypes"; 
import { SubListEntry } from "./ApiTypes"; 
import { PlanInfoBasic } from "./ApiTypes"; 
import { FacilitySub } from "./ApiTypes"; 
import { DeleteConfirm } from "./ApiTypes"; 
import { ChangeEmailReq } from "./ApiTypes"; 
import { VehicleDetails } from "./ApiTypes"; 
import { VehicleLink } from "./ApiTypes"; 
import { FacilityInvoice } from "./ApiTypes"; 
import { ResetCodeCheckReq } from "./ApiTypes"; 
import { ResetPasswordReq } from "./ApiTypes"; 
import { AccessKey } from "./ApiTypes"; 
import { AccessKeyListEntry } from "./ApiTypes"; 
import { AccessKeyLinkInfo } from "./ApiTypes"; 
import { SubscriptionInfo } from "./ApiTypes"; 
import { AccessKeyReq } from "./ApiTypes"; 
import { AccessKeyAssignSub } from "./ApiTypes"; 
import { AccessKeyParkerAssignReq } from "./ApiTypes"; 
import { AccessKeyVehicleSubAssignReq } from "./ApiTypes"; 
import { SubscriptionParkerAccessKey } from "./ApiTypes"; 
import { SubscriptionParkerVehicleAccessKey } from "./ApiTypes"; 
import { FacilityStats } from "./ApiTypes"; 
import { SubscriptionStat } from "./ApiTypes"; 
import { ReservationStat } from "./ApiTypes"; 
import { OrderStat } from "./ApiTypes"; 
import { ParkerSubInfo } from "./ApiTypes"; 
import { FacilityPayment } from "./ApiTypes"; 
import { BalanceChange } from "./ApiTypes"; 
import { ImportPaymentReq } from "./ApiTypes"; 
import { Session } from "./ApiTypes"; 
import { SessionSubscription } from "./ApiTypes"; 
import { SessionAccessPeriod } from "./ApiTypes"; 
import { PlanInvoiceReq } from "./ApiTypes"; 
import { PlanInvoiceResp } from "./ApiTypes"; 
import { InvoiceInfo } from "./ApiTypes"; 
import { InvoiceArgs } from "./ApiTypes"; 
import { SubscriptionParkerInviteReq } from "./ApiTypes"; 
import { SubscriptionParkerChangeReq } from "./ApiTypes"; 
import { SubscriptionParkerRemoveReq } from "./ApiTypes"; 
import { VehicleAddReq } from "./ApiTypes"; 
import { VehicleDeleteReq } from "./ApiTypes"; 
import { VehicleLinkResp } from "./ApiTypes"; 
import { OrderCustomReq } from "./ApiTypes"; 
import { OrderCustomItemReq } from "./ApiTypes"; 
import { FacilityPayout } from "./ApiTypes"; 
import { PayoutTransaction } from "./ApiTypes"; 
import { PayoutTransactionPayment } from "./ApiTypes"; 
import { OrderAdjustReq } from "./ApiTypes"; 
import { PaymentAdjustReq } from "./ApiTypes"; 
import { PlanBillInitResp } from "./ApiTypes"; 
import { PlanBillConfirmResp } from "./ApiTypes"; 
import { cents } from "./Money";
import { createLocalDateTime, createLocalTime, createLocalDate, createInstant } from "./ApiConverters";
import { Duration } from "@js-joda/core";
import { FacilityLite } from "./ApiTypes";

export function parseOperator( o: OperatorApi ): Operator {
    return {
        operatorId: o.operatorId,
        name: o.name,
        address: parseUsAddress( o.address ),
        emailAddress: o.emailAddress,
        phoneNumber: o.phoneNumber,
        website: o.website,
        logoUrl: o.logoUrl,
        topTitle: o.topTitle,
        topText: o.topText,
        bottomLeftTitle: o.bottomLeftTitle,
        bottomLeftText: o.bottomLeftText,
        bottomRightTitle: o.bottomRightTitle,
        bottomRightText: o.bottomRightText,
    }
}

export function parseFacilityInfo( f: FacilityInfoApi ): FacilityInfo {
    return {
        facilityId: f.facilityId,
        operatorId: f.operatorId,
        name: f.name,
        description: f.description,
        timeZone: f.timeZone,
        address: parseUsAddress( f.address ),
        coordinates: parseCoordinates( f.coordinates ),
        listImageId: f.listImageId != null ? f.listImageId : null,
        entryInstructions: f.entryInstructions,
        phoneNumber: f.phoneNumber,
        emailAddress: f.emailAddress,
        clearanceInches: f.clearanceInches,
        hasIntegrationsEnabled: f.hasIntegrationsEnabled,
        features: f.features
    }
}

export function parseUsAddress( u: UsAddressApi ): UsAddress {
    return {
        addressLine1: u.addressLine1,
        addressLine2: u.addressLine2,
        city: u.city,
        state: u.state,
        zipCode: u.zipCode,
        latitude: u.latitude,
        longitude: u.longitude,
        timezone: u.timezone
    }
}

export function parseCoordinates( c: CoordinatesApi ): Coordinates {
    return {
        lat: c.lat,
        lng: c.lng,
    }
}

export function parseOrderDebt( o: OrderDebtApi ): OrderDebt {
    return {
        orderId: o.orderId,
        createdWhen: createInstant( o.createdWhen ),
        orderTotal: cents( o.orderTotal ),
        paid: cents( o.paid ),
        unpaid: cents( o.unpaid ),
    }
}

export function parseVehicle( v: VehicleApi ): Vehicle {
    return {
        vehicleId: v.vehicleId,
        make: v.make,
        model: v.model,
        color: v.color,
        stateCode: v.stateCode,
        licensePlateNumber: v.licensePlateNumber,
    }
}

export function parseRateProgram( r: RateProgramApi ): RateProgram {
    return {
        rateProgramId: r.rateProgramId,
        facilityId: r.facilityId,
        name: r.name,
        start: createLocalDateTime( r.start ),
        end: r.end != null ? createLocalDateTime( r.end ) : null,
        inAfter: r.inAfter != null ? createLocalTime( r.inAfter ) : null,
        inBefore: r.inBefore != null ? createLocalTime( r.inBefore ) : null,
        outAfter: r.outAfter != null ? createLocalTime( r.outAfter ) : null,
        outBefore: r.outBefore != null ? createLocalTime( r.outBefore ) : null,
        applicableDays: r.applicableDays,
        isEvent: r.isEvent,
        isValidation: r.isValidation,
        entries: r.entries.map( el => parseRateEntry( el ) ),
        isActive: r.isActive,
        canBeValidated: r.canBeValidated,
        validationType: r.validationType,
        encodedRateProgramId: r.encodedRateProgramId,
        isSpecialRate: r.isSpecialRate
    }
}

export function parseRateProgramDropdown(
  rates: RateProgramDropdownApi[]
): RateProgramDropdown[] {
  return rates.map(r => ({
    id: r.id,
    name: r.name,
  }));
}

export function parseRateEntry( r: RateEntryApi ): RateEntry {
    return {
        rateEntryId: r.rateEntryId,
        rateProgramId: r.rateProgramId,
        upTo: Duration.ofMinutes( r.upTo ),
        rate: cents( r.rate ),
    }
}

export function parseFacilityImage( f: FacilityImageApi ): FacilityImage {
    return {
        facilityImageId: f.facilityImageId,
        storedImageId: f.storedImageId,
        orderId: f.orderId,
        caption: f.caption,
        altText: f.altText,
    }
}

export function parseListedPlan( l: ListedPlanApi ): ListedPlan {
    return {
        planId: l.planId,
        planEntryId: l.planEntryId,
        name: l.name,
        description: l.description,
        accessHours: l.accessHours,
        dayOfMonthInvoice: l.dayOfMonthInvoice,
        dayOfMonthDue: l.dayOfMonthDue,
        dayOfMonthLate: l.dayOfMonthLate,
        price: cents( l.price ),
    }
}

export function parseOrder( o: OrderApi ): Order {
    return {
        orderId: o.orderId,
        initiator: o.initiator,
        initiatedByStaffId: o.initiatedByStaffId != null ? o.initiatedByStaffId : null,
        parkerId: o.parkerId,
        facilityId: o.facilityId,
        price: cents( o.price ),
        createdWhen: createInstant( o.createdWhen ),
        processorPaymentIntentKey: o.processorPaymentIntentKey != null ? o.processorPaymentIntentKey : null,
        type: o.type,
        facility: parseFacilityInfo( o.facility ),
        submittedWhen: o.submittedWhen != null ? createInstant( o.submittedWhen ) : null,
        balance: parseOrderBalance( o.balance ),
        summary: o.summary,
    }
}

export function parseOrderDetails( o: OrderDetailsApi ): OrderDetails {
    return {
        order: parseOrder( o.order ),
        balanceChanges: o.balanceChanges.map( el => parseOrderBalance( el ) ),
        summary: o.summary,
    }
}

export function parseOrderBalance( o: OrderBalanceApi ): OrderBalance {
    return {
        orderBalanceId: o.orderBalanceId,
        type: o.type,
        orderId: o.orderId,
        createdWhen: createInstant( o.createdWhen ),
        debt: cents( o.debt ),
        paid: cents( o.paid ),
        balance: cents( o.balance ),
        totalDebt: cents( o.totalDebt ),
        totalPaid: cents( o.totalPaid ),
        reason: o.reason != null ? o.reason : null,
        paymentId: o.paymentId != null ? o.paymentId : null,
    }
}

export function parseInvoice( i: InvoiceApi ): Invoice {
    return {
        invoiceId: i.invoiceId,
        invoiceNumber: i.invoiceNumber,
        createdWhen: createInstant( i.createdWhen ),
        dueWhen: createLocalDate( i.dueWhen ),
        openingBalance: cents( i.openingBalance ),
        amountDue: cents( i.amountDue ),
        endingBalance: cents( i.endingBalance ),
        emailSentWhen: i.emailSentWhen != null ? createInstant( i.emailSentWhen ) : null,
        facility: parseFacilityInfo( i.facility ),
        orders: i.orders.map(o => parseOrderInfo(o)),
        parker: parseParkerInfo( i.parker ),
    }
}

export function parsePayment( p: PaymentApi ): Payment {
    return {
        paymentId: p.paymentId,
        parentPaymentId: p.parentPaymentId != null ? p.parentPaymentId : null,
        facilityId: p.facilityId,
        facility: parseFacilityLite(p.facility),
        type: p.type,
        amount: cents( p.amount ),
        remaining: cents( p.remaining ),
        unapplied: cents( p.unapplied ),
        paymentMethod: p.paymentMethod,
        paymentIntentKey: p.paymentIntentKey != null ? p.paymentIntentKey : null,
        chargeKey: p.chargeKey != null ? p.chargeKey : null,
        paymentKey: p.paymentKey != null ? p.paymentKey : null,
        changes: p.changes.map( el => parsePaymentChange( el ) ),
        applications: p.applications.map( el => parseApplyPayment( el ) ),
        createdWhen: createInstant( p.createdWhen ),
        paidWhen: createInstant( p.paidWhen ),
        status: p.status,
        checkDate: p.checkDate,
        checkMemo: p.checkMemo,
        checkNumber: p.checkNumber,
        staffName: p.staffName
    }
}

export function parseApplyPayment( a: ApplyPaymentApi ): ApplyPayment {
    return {
        orderBalanceId: a.orderBalanceId,
        type: a.type,
        facilityId: a.facilityId,
        parkerId: a.parkerId,
        orderId: a.orderId,
        debt: cents( a.debt ),
        paid: cents( a.paid ),
        balance: cents( a.balance ),
        totalDebt: cents( a.totalDebt ),
        totalPaid: cents( a.totalPaid ),
        createdWhen: createInstant( a.createdWhen ),
    }
}

export function parseOrderInfo( o: OrderInfoApi ): OrderInfo {
    return {
        orderId: o.orderId,
        initiator: o.initiator,
        initiatedByStaffId: o.initiatedByStaffId != null ? o.initiatedByStaffId : null,
        parkerId: o.parkerId,
        facilityId: o.facilityId,
        price: cents( o.price ),
        createdWhen: createInstant( o.createdWhen ),
        processorPaymentIntentKey: o.processorPaymentIntentKey != null ? o.processorPaymentIntentKey : null,
        orderType: o.orderType,
        submittedWhen: o.submittedWhen != null ? createInstant( o.submittedWhen ) : null,
        balance: parseOrderBalance( o.balance ),
        summary: o.summary,
    }
}

export function parsePaymentChange( p: PaymentChangeApi ): PaymentChange {
    return {
        paymentId: p.paymentId,
        parentPaymentId: p.parentPaymentId != null ? p.parentPaymentId : null,
        facilityId: p.facilityId,
        parkerId: p.parkerId,
        type: p.type,
        amount: cents( p.amount ),
        balance: cents( p.balance ),
        createdWhen: createInstant( p.createdWhen ),
    }
}

export function parseLogInReq( l: LogInReqApi ): LogInReq {
    return {
        emailAddress: l.emailAddress,
        password: l.password,
    }
}

export function parseChangeNameReq( c: ChangeNameReqApi ): ChangeNameReq {
    return {
        name: c.name,
    }
}

export function parseChangePhoneReq( c: ChangePhoneReqApi ): ChangePhoneReq {
    return {
        phoneNumber: c.phoneNumber,
    }
}

export function parseStripeLinkResp( s: StripeLinkRespApi ): StripeLinkResp {
    return {
        isOnboarded: s.isOnboarded,
        connectLink: s.connectLink != null ? s.connectLink : null,
    }
}

export function parseChangePasswordReq( c: ChangePasswordReqApi ): ChangePasswordReq {
    return {
        currentPassword: c.currentPassword,
        newPassword: c.newPassword,
    }
}

export function parseForgotPasswordReq( f: ForgotPasswordReqApi ): ForgotPasswordReq {
    return {
        emailAddress: f.emailAddress,
    }
}

export function parseStaffNotification( s: StaffNotificationApi ): StaffNotification {
    return {
        staffId: s.staffId,
        createdWhen: s.createdWhen,
        staffNotificationId: s.staffNotificationId,
        notificationType: s.notificationType
    }
}

export function parseStaff( s: StaffApi ): Staff {

    return s.staffId != undefined ? {
        staffId: s.staffId,
        role: s.role,
        roles: [],
        operatorId: s.operatorId,
        name: s.name,
        note: s.note,
        emailAddress: s.emailAddress,
        phoneNumber: s.phoneNumber,
        createdWhen: createInstant( s.createdWhen ),
        removedWhen: s.removedWhen != null ? createInstant( s.removedWhen ) : null,
    }: {} as any
}

export function parseStaffUpdateReq( s: StaffUpdateReqApi ): StaffUpdateReq {
    return {
        name: s.name,
        emailAddress: s.emailAddress,
        phoneNumber: s.phoneNumber,
        note: s.note,
    }
}

export function parseInviteStaffReq( i: InviteStaffReqApi ): InviteStaffReq {
    return {
        role: i.role,
        name: i.name,
        emailAddress: i.emailAddress,
        phoneNumber: i.phoneNumber,
        password: i.password,
        note: i.note,
    }
}

export function parseSearchResult( s: SearchResultApi ): SearchResult {
    return {
        searchResultId: s.searchResultId,
        type: s.type,
        id: s.id,
        name: s.name,
        facilityId: s.facilityId,
        facilityName: s.facilityName
    }
}

export function parsePlanCreateReq( p: PlanCreateReqApi ): PlanCreateReq {
    return {
        facilityId: p.facilityId,
        name: p.name,
        accessHours: p.accessHours,
        description: p.description,
        dayOfMonthInvoice: p.dayOfMonthInvoice,
        dayOfMonthDue: p.dayOfMonthDue,
        dayOfMonthLate: p.dayOfMonthLate,
        initialPrice: p.initialPrice,
        terms: p.terms,
        isPrivate: p.isPrivate,
    }
}

export function parsePlanUpdateReq( p: PlanUpdateReqApi ): PlanUpdateReq {
    return {
        planEntryId: p.planEntryId,
        name: p.name,
        description: p.description,
        accessHours: p.accessHours,
        planPriceId: p.planPriceId != null ? p.planPriceId : null,
        dayOfMonthInvoice: p.dayOfMonthInvoice,
        dayOfMonthDue: p.dayOfMonthDue,
        dayOfMonthLate: p.dayOfMonthLate,
        note: p.note,
        terms: p.terms,
    }
}

export function parsePlanPriceAddReq( p: PlanPriceAddReqApi ): PlanPriceAddReq {
    return {
        name: p.name,
        price: cents( p.price ),
        couponCode: p.couponCode
    }
}

export function parsePlanPriceListResp( p: PlanPriceListRespApi ): PlanPriceListResp {
    return {
        planPriceId: p.planPriceId,
        name: p.name,
        price: p.price,
        couponCode: p.couponCode
    }
}

export function parseReservation( r: ReservationApi ): Reservation {
    return {
        reservationId: r.reservationId,
        facilityId: r.facilityId,
        parkerId: r.parkerId,
        start: createLocalDateTime( r.start ),
        end: createLocalDateTime( r.end ),
        actualStart: createInstant( r.actualStart ),
        actualEnd: createInstant( r.actualEnd ),
        duration: Duration.ofMinutes( r.duration ),
        rateProgramId: r.rateProgramId,
        price: cents( r.price ),
        createdWhen: createInstant( r.createdWhen ),
        rateProgram: parseRateProgramInfo( r.rateProgram ),
        validationRequestId: r.validationRequestId,
        confirmationNum: r.confirmationNum,
        spaces: r.spaces
    }
}

export function parseSubscription( s: SubscriptionApi ): Subscription {
    return {
        subscriptionId: s.subscriptionId,
        parkerId: s.parkerId,
        status: s.status,
        start: createLocalDate( s.start ),
        planEntryId: s.planEntryId,
        planPriceId: s.planPriceId,
        quantity: s.quantity,
        end: s.end != null ? createLocalDate( s.end ) : null,
        isAccountsReceivable: s.isAccountsReceivable,
        price: cents( s.price ),
        plan: parsePlanInfo( s.plan ),
        prices: s.prices,
        facility: parseFacilityInfo( s.facility ),
        accessPeriods: s.accessPeriods.map( el => parseAccessPeriodInfo( el ) ),
        parkers: s.parkers.map( el => parseSubscriptionParker( el ) ),
        vehicles: s.vehicles.map( el => parseVehicle( el ) ),
        paymentMethod: s.paymentMethod != null ? s.paymentMethod : null,
        isEnhancedGroup: s.isEnhancedGroup
    }
}

export function parsePlanInfo( p: PlanInfoApi ): PlanInfo {
    return {
        planId: p.planId,
        facilityId: p.facilityId,
        name: p.name,
        description: p.description,
        accessHours: p.accessHours,
        dayOfMonthInvoice: p.dayOfMonthInvoice,
        dayOfMonthDue: p.dayOfMonthDue,
        dayOfMonthLate: p.dayOfMonthLate,
    }
}

export function parseFacility( f: FacilityApi ): Facility {
    return {
        facilityId: f.facilityId,
        name: f.name,
        description: f.description,
        timeZone: f.timeZone,
        address: parseUsAddress( f.address ),
        coordinates: parseCoordinates( f.coordinates ),
        listImageId: f.listImageId != null ? f.listImageId : null,
        entryInstructions: f.entryInstructions,
        physicalCapacity: f.physicalCapacity,
        enforcedCapacity: f.enforcedCapacity,
        clearanceInches: f.clearanceInches,
        website: f.website,
        emailAddress: f.emailAddress,
        phoneNumber: f.phoneNumber,
        images: f.images.map( el => parseFacilityImage( el ) ),
        hourlyRates: f.hourlyRates.map( el => parseRateProgram( el ) ),
        listedPlans: f.listedPlans.map( el => parseListedPlan( el ) ),
        timezone: f.timeZone,
        features: f.features,
        payoutAccount: f.payoutAccount,
    }
}

export function parseFacilityLite( f: FacilityLiteApi ): FacilityLite {
    return {
        facilityId: f.facilityId,
        name: f.name,
        description: f.description,
        timeZone: f.timeZone,
        address: parseUsAddress( f.address ),
        coordinates: parseCoordinates( f.coordinates ),
        listImageId: f.listImageId != null ? f.listImageId : null,
        entryInstructions: f.entryInstructions,
        physicalCapacity: f.physicalCapacity,
        enforcedCapacity: f.enforcedCapacity,
        clearanceInches: f.clearanceInches,
        website: f.website,
        emailAddress: f.emailAddress,
        phoneNumber: f.phoneNumber
    }
}

export function parseParker( p: ParkerApi ): Parker {
    return {
        parkerId: p.parkerId,
        name: p.name,
        emailAddress: p.emailAddress,
        phoneNumber: p.phoneNumber != null ? p.phoneNumber : null,
        note: p.note,
    }
}

export function parseParkerListEntry( p: ParkerListEntryApi ): ParkerListEntry {
    return {
        parkerId: p.parkerId,
        name: p.name,
        emailAddress: p.emailAddress,
        phoneNumber: p.phoneNumber != null ? p.phoneNumber : null,
        note: p.note,
        balance: cents( p.balance ),
        monthly: cents( p.monthly ),
    }
}

export function parseParkerDetails( p: ParkerDetailsApi ): ParkerDetails {
    return {
        parkerId: p.parkerId,
        name: p.name,
        note: p.note,
        emailAddress: p.emailAddress,
        phoneNumber: p.phoneNumber != null ? p.phoneNumber : null,
        balance: cents( p.balance ),
        subscriptions: p.subscriptions.map( el => parseParkerSubInfo( el ) ),
        reservations: p.reservations.map( el => parseReservation( el ) ),
        vehicles: p.vehicles.map( el => parseVehicle( el ) ),
        subscriptionParkerId: p.subscriptionParkerId != null ? p.subscriptionParkerId : null,
        staffRole: p.staffRole,
        nonRenewedSubscriptionIds: p.nonRenewedSubscriptionIds
    }
}

export function parseParkerDetailsGridResult( p: ParkerDetailsGridResultApi ): ParkerDetailsGridResult {
    return {
        parkerDetailsGrid: p.parkerDetailsGrid.map( el => parseParkerDetailsGrid( el ) ),
        timeZone: p.timeZone,
    }
}

export function parseParkerDetailsGrid( p: ParkerDetailsGridApi ): ParkerDetailsGrid {
    return {
        parkerId: p.parkerId,
        name: p.name,
        note: p.note,
        emailAddress: p.emailAddress,
        phoneNumber: p.phoneNumber != null ? p.phoneNumber : null,
        balance: cents( p.balance ),
        status: p.status,
        mrr: cents( p.mrr ),
        guestCount: p.guestCount,
        spotCount: p.spotCount,
        planCount: p.planCount,
        createdWhen: createInstant( p.createdWhen ),
        planName: p.planName,
        unitPrice: cents( p.unitPrice ),
        subscriptionId: p.subscriptionId,
        isExpired: p.isExpired,
        isActive: p.isActive,
        inviteId: p.inviteId,
        hasAutoPay: p.hasAutoPay,
        hasNonRenewedPeriod: p.hasNonRenewedPeriod,
    }
}

export function parseCheckCreateReq( c: CheckCreateReqApi ): CheckCreateReq {
    return {
        checkDate: createLocalDate( c.checkDate ),
        checkNumber: c.checkNumber,
        checkMemo: c.checkMemo,
        amount: cents( c.amount ),
    }
}

export function parsePmtApply( p: PmtApplyApi ): PmtApply {
    return {
        orderId: p.orderId,
        amount: cents( p.amount ),
    }
}

export function parsePlan( p: PlanApi ): Plan {
    return {
        planId: p.planId,
        planEntryId: p.planEntryId,
        name: p.name,
        description: p.description,
        accessHours: p.accessHours,
        dayOfMonthInvoice: p.dayOfMonthInvoice,
        dayOfMonthDue: p.dayOfMonthDue,
        dayOfMonthLate: p.dayOfMonthLate,
        planPriceId: p.planPriceId != null ? p.planPriceId : null,
        planPrice: p.planPrice != null ? parsePlanPriceInfo( p.planPrice ) : null,
        prices: p.prices.map( el => parsePlanPriceDetails( el ) ),
        note: p.note,
        isPrivate: p.isPrivate,
        prorate: p.prorate,
        terms: p.terms,
        approvalEmailText: p.approvalEmailText,
        isOneTermPlan: p.isOneTermPlan,
        renewalFailureDeactivateAfterDays: p.renewalFailureDeactivateAfterDays
    }
}

export function parsePlanDetails( p: PlanDetailsApi ): PlanDetails {
    return {
        planId: p.planId,
        planEntryId: p.planEntryId,
        name: p.name,
        description: p.description,
        accessHours: p.accessHours,
        dayOfMonthInvoice: p.dayOfMonthInvoice,
        dayOfMonthDue: p.dayOfMonthDue,
        dayOfMonthLate: p.dayOfMonthLate,
        planPriceId: p.planPriceId != null ? p.planPriceId : null,
        terms: p.terms,
        approvalEmailText: p.approvalEmailText,
        isPrivate: p.isPrivate,
        planPrice: p.planPrice != null ? parsePlanPriceInfo( p.planPrice ) : null,
        prices: p.prices.map( el => parsePlanPriceDetails( el ) ),
        history: p.history.map( el => parsePlanChange( el ) ),
        prorate: p.prorate,
        renewalFailureDeactivateAfterDays: p.renewalFailureDeactivateAfterDays
    }
}

export function parsePlanChange( p: PlanChangeApi ): PlanChange {
    return {
        planEntryId: p.planEntryId,
        planId: p.planId,
        name: p.name,
        description: p.description,
        accessHours: p.accessHours,
        dayOfMonthInvoice: p.dayOfMonthInvoice,
        dayOfMonthDue: p.dayOfMonthDue,
        dayOfMonthLate: p.dayOfMonthLate,
        planPriceId: p.planPriceId != null ? p.planPriceId : null,
        planPrice: p.planPrice != null ? parsePlanPriceInfo( p.planPrice ) : null,
        createdWhen: createInstant( p.createdWhen ),
        createdByStaffId: p.createdByStaffId,
        note: p.note,
    }
}

export function parsePlanPriceInfo( p: PlanPriceInfoApi ): PlanPriceInfo {
    return {
        planPriceId: p.planPriceId,
        planId: p.planId,
        name: p.name,
        price: cents( p.price ),
        createdByStaffId: p.createdByStaffId,
        createdWhen: createInstant( p.createdWhen ),
    }
}

export function parsePlanPriceDetails( p: PlanPriceDetailsApi ): PlanPriceDetails {
    return {
        planPriceId: p.planPriceId,
        planId: p.planId,
        name: p.name,
        price: cents( p.price ),
        createdByStaffId: p.createdByStaffId,
        createdWhen: createInstant( p.createdWhen ),
        subscribers: p.subscribers.map( el => parseSubscriberInfo( el ) ),
        couponCode: p.couponCode
    }
}

export function parseInviteParkerReq( i: InviteParkerReqApi ): InviteParkerReq {
    return {
        name: i.name,
        emailAddress: i.emailAddress,
        phoneNumber: i.phoneNumber != null ? i.phoneNumber : null,
        planId: i.planId,
        planPriceId: i.planPriceId,
        quantity: i.quantity,
        message: i.message,
        requirePayment: i.requirePayment,
        startDate: i.startDate,
        IsEnhancedGroup: i.IsEnhancedGroup
    }
}

export function parseFacilityCreateReq( f: FacilityCreateReqApi ): FacilityCreateReq {
    return {
        name: f.name,
        address: parseUsAddress( f.address ),
        description: f.description,
        instructions: f.instructions,
        postedCapacity: f.postedCapacity,
        enforcedCapacity: f.enforcedCapacity,
        website: f.website,
        emailAddress: f.emailAddress,
        phoneNumber: f.phoneNumber,
        clearanceInches: f.clearanceInches,
        imageThumb: f.imageThumb,
        bannerImage: f.bannerImage,
        latitude: f.latitude,
        longitude: f.longitude,
        timezone: f.timezone,
    }
}

export function parseFacilityUpdateReq( f: FacilityUpdateReqApi ): FacilityUpdateReq {
    return {
        facilityId: f.facilityId,
        name: f.name,
        address: parseUsAddress( f.address ),
        description: f.description,
        instructions: f.instructions,
        postedCapacity: f.postedCapacity,
        enforcedCapacity: f.enforcedCapacity,
        clearanceInches: f.clearanceInches,
        website: f.website,
        emailAddress: f.emailAddress,
        phoneNumber: f.phoneNumber,
        latitude: f.latitude,
        longitude: f.longitude,
        timezone: f.timezone
    }
}

export function parsePaymentSavedReports( p: PaymentSavedReportsApi ): PaymentSavedReports {
    return {
        name: p.name,
        savedReportId: p.savedReportId,
        filter:  p.filter
    }
}

export function parseSubscriptionSavedReports( p: SubscriptionSavedReportsApi ): SubscriptionSavedReports {
    return {
        name: p.name,
        savedReportId: p.savedReportId,
        filter: p.filter
    }
}

export function parseParkerAgingRecord( p: ParkerAgingRecordApi ): ParkerAgingRecord {
    return {
        name: p.name ,
        emailAddress: p.emailAddress,
        balance30Days: p.balance30Days,
        balance60Days: p.balance60Days,
        balance90Days: p.balance90Days,
        totalBalance: p.totalBalance
    }
}

export function parseParkerInfo( p: ParkerInfoApi ): ParkerInfo {
    return {
        parkerId: p.parkerId,
        operatorId: p.operatorId,
        name: p.name,
        emailAddress: p.emailAddress,
        phoneNumber: p.phoneNumber != null ? p.phoneNumber : null,
        createdWhen: createInstant( p.createdWhen ),
        vehicles: p.vehicles,
        isManaged: p.isManaged
    }
}

export function parseRateProgramData( r: RateProgramDataApi ): RateProgramData {
    return {
        facilityId: r.facilityId,
        name: r.name,
        start: createLocalDateTime( r.start ),
        end: r.end != null ? createLocalDateTime( r.end ) : null,
        inAfter: r.inAfter != null ? createLocalTime( r.inAfter ) : null,
        inBefore: r.inBefore != null ? createLocalTime( r.inBefore ) : null,
        outAfter: r.outAfter != null ? createLocalTime( r.outAfter ) : null,
        outBefore: r.outBefore != null ? createLocalTime( r.outBefore ) : null,
        isEvent: r.isEvent,
        isValidation: r.isValidation,
        applicableDays: r.applicableDays,
        entries: r.entries.map( el => parseRateEntryData( el ) ),
        canBeValidated: r.canBeValidated,
        validationType: r.validationType,
        isSpecialRate: r.isSpecialRate
    }
}

export function parseRateProgramInfo( r: RateProgramInfoApi ): RateProgramInfo {
    return {
        rateProgramId: r.rateProgramId,
        facilityId: r.facilityId,
        name: r.name,
        start: createLocalDateTime( r.start ),
        end: r.end != null ? createLocalDateTime( r.end ) : null,
        inAfter: r.inAfter != null ? createLocalTime( r.inAfter ) : null,
        inBefore: r.inBefore != null ? createLocalTime( r.inBefore ) : null,
        outAfter: r.outAfter != null ? createLocalTime( r.outAfter ) : null,
        outBefore: r.outBefore != null ? createLocalTime( r.outBefore ) : null,
        isEvent: r.isEvent,
    }
}

export function parseRateEntryData( r: RateEntryDataApi ): RateEntryData {
    return {
        upTo: Duration.ofMinutes( r.upTo ),
        rate: cents( r.rate ),
    }
}

export function parseSubscriberInfo( s: SubscriberInfoApi ): SubscriberInfo {
    return {
        parkerId: s.parkerId,
        name: s.name,
        note: s.note,
        emailAddress: s.emailAddress,
        phoneNumber: s.phoneNumber != null ? s.phoneNumber : null,
        quantity: s.quantity,
    }
}

export function parseSubscriptionUpdateReq( s: SubscriptionUpdateReqApi ): SubscriptionUpdateReq {
    return {
        subscriptionEntryId: s.subscriptionEntryId,
        subscriptionId: s.subscriptionId,
        planPriceId: s.planPriceId,
        quantity: s.quantity,
        status: s.status,
        start: createLocalDate( s.start ),
        end: s.end != null ? createLocalDate( s.end ) : null,
        isAccountsReceivable: s.isAccountsReceivable,
        isLateFeeEnabled: s.isLateFeeEnabled,
        applyQuantityChangeNow: s.applyQuantityChangeNow
    }
}

export function parseSubEntry( s: SubEntryApi ): SubEntry {
    return {
        subscriptionEntryId: s.subscriptionEntryId,
        subscriptionId: s.subscriptionId,
        planId: s.planId,
        planEntryId: s.planEntryId,
        planPriceId: s.planPriceId,
        quantity: s.quantity,
        status: s.status,
        start: createLocalDate( s.start ),
        end: s.end != null ? createLocalDate( s.end ) : null,
        isAccountsReceivable: s.isAccountsReceivable,
        isLateFeeEnabled: s.isLateFeeEnabled,
        createdWhen: createInstant( s.createdWhen ),
    }
}

export function parseSubEntryForEdit( s: SubEntryForEditApi ): SubEntryForEdit {
    return {
        prices: s.prices.map( el => parsePlanPriceInfo( el ) ),
        subscriptionEntryId: s.subscriptionEntryId,
        subscriptionId: s.subscriptionId,
        planId: s.planId,
        planEntryId: s.planEntryId,
        planPriceId: s.planPriceId,
        quantity: s.quantity,
        status: s.status,
        start: createLocalDate( s.start ),
        end: s.end != null ? createLocalDate( s.end ) : null,
        isAccountsReceivable: s.isAccountsReceivable,
        isLateFeeEnabled: s.isLateFeeEnabled,
        createdWhen: createInstant( s.createdWhen ),
        applyQuantityChangeNow: s.applyQuantityChangeNow
    }
}

export function parseAccessPeriodInfo( a: AccessPeriodInfoApi ): AccessPeriodInfo {
    return {
        accessPeriodId: a.accessPeriodId,
        subscriptionEntryId: a.subscriptionEntryId,
        quantity: a.quantity,
        start: createLocalDate( a.start ),
        end: createLocalDate( a.end ),
        isDelivered: a.isDelivered,
        price: cents( a.price ),
    }
}

export function parseSubscriptionParker( s: SubscriptionParkerApi ): SubscriptionParker {
    return {
        parker: parseParkerInfo( s.parker ),
        quantity: s.quantity,
        vehicles: s.vehicles.length > 0 ? s.vehicles.map( el => parseVehicle( el ) ) : [],
        subscriptionGroupName: s.subscriptionGroupName,
        subscriptionGroupId: s.subscriptionGroupId,
        startDate: s.startDate != null ? createInstant( s.startDate ) : null
    }
}

export function parseParkerUpdateReq( p: ParkerUpdateReqApi ): ParkerUpdateReq {
    return {
        name: p.name,
        emailAddress: p.emailAddress,
        phoneNumber: p.phoneNumber != null ? p.phoneNumber : null,
        note: p.note,
    }
}

export function parseSubListEntry( s: SubListEntryApi ): SubListEntry {
    return {
        subscriptionId: s.subscriptionId,
        parkerId: s.parkerId,
        status: s.status,
        quantity: s.quantity,
        unitPrice: s.unitPrice != null ? s.unitPrice : null,
        price: s.price != null ? s.price : null,
        plan: parsePlanInfoBasic( s.plan ),
        facility: parseFacilityInfo( s.facility ),
    }
}

export function parsePlanInfoBasic( p: PlanInfoBasicApi ): PlanInfoBasic {
    return {
        planId: p.planId,
        planEntryId: p.planEntryId,
        name: p.name,
        accessHours: p.accessHours,
    }
}

export function parseFacilitySub( f: FacilitySubApi ): FacilitySub {
    return {
        subscriptionId: f.subscriptionId,
        parkerId: f.parkerId,
        status: f.status,
        quantity: f.quantity,
        unitPrice: cents( f.unitPrice ),
        price: cents( f.price ),
        createdWhen: createInstant( f.createdWhen ),
        parker: parseParkerInfo( f.parker ),
        plan: parsePlanInfoBasic( f.plan ),
        facility: parseFacilityInfo( f.facility ),
    }
}


export function parseFacilitySubByParker( f: FacilitySubApi ): FacilitySubByParker {
    return {
        subscriptionId: f.subscriptionId,
        parkerId: f.parkerId,
        status: f.status,
        quantity: f.quantity,
        unitPrice: f.unitPrice,
        price: f.price,
        createdWhen: createInstant( f.createdWhen ),
        parker: parseParkerInfo( f.parker ),
        plan: parsePlanInfoBasic( f.plan ),
        facility: parseFacilityInfo( f.facility ),
    }
}

export function parseDeleteConfirm( d: DeleteConfirmApi ): DeleteConfirm {
    return {
        deleteCode: d.deleteCode,
    }
}

export function parseChangeEmailReq( c: ChangeEmailReqApi ): ChangeEmailReq {
    return {
        currentPassword: c.currentPassword,
        newEmailAddress: c.newEmailAddress,
    }
}

export function parseVehicleDetails( v: VehicleDetailsApi ): VehicleDetails {
    return {
        vehicleId: v.vehicleId,
        make: v.make,
        model: v.model,
        color: v.color,
        stateCode: v.stateCode,
        licensePlateNumber: v.licensePlateNumber,
        links: v.links.map( el => parseVehicleLink( el ) ),
    }
}

export function parseVehicleLink( v: VehicleLinkApi ): VehicleLink {
    return {
        type: v.type,
        reservationId: v.reservationId != null ? v.reservationId : null,
        subscriptionId: v.subscriptionId != null ? v.subscriptionId : null,
        reservation: v.reservation != null ? parseReservation( v.reservation ) : null,
        subscription: v.subscription != null ? parseSubListEntry( v.subscription ) : null,
    }
}

export function parseFacilityInvoice( f: FacilityInvoiceApi ): FacilityInvoice {
    return {
        invoiceId: f.invoiceId,
        invoiceNumber: f.invoiceNumber,
        createdWhen: createInstant( f.createdWhen ),
        dueWhen: createLocalDate( f.dueWhen ),
        openingBalance: cents( f.openingBalance ),
        amountDue: cents( f.amountDue ),
        endingBalance: cents( f.endingBalance ),
        emailSentWhen: f.emailSentWhen != null ? createInstant( f.emailSentWhen ) : null,
        orders: f.orders.map(o => parseOrderInfo(o)),
        parker: parseParkerInfo( f.parker ),
    }
}

export function parseResetCodeCheckReq( r: ResetCodeCheckReqApi ): ResetCodeCheckReq {
    return {
        resetPasswordCode: r.resetPasswordCode,
    }
}

export function parseResetPasswordReq( r: ResetPasswordReqApi ): ResetPasswordReq {
    return {
        resetPasswordCode: r.resetPasswordCode,
        newPassword: r.newPassword,
    }
}

export function parseAccessKey( a: AccessKeyApi ): AccessKey {
    return {
        accessKeyId: a.accessKeyId,
        facilityId: a.facilityId,
        accessKeyNumber: a.accessKeyNumber,
        createdWhen: createInstant( a.createdWhen ),
        createdByStaff: parseStaff( a.createdByStaff ),
        note: a.note,
        facility: parseFacilityInfo( a.facility ),
        links: a.links.map( el => parseAccessKeyLinkInfo( el ) ),
    }
}

export function parseAccessKeyListEntry( a: AccessKeyListEntryApi ): AccessKeyListEntry {
    return {
        accessKeyId: a.accessKeyId,
        accessKeyNumber: a.accessKeyNumber,
        createdWhen: createInstant( a.createdWhen ),
        note: a.note,
    }
}

export function parseAccessKeyLinkInfo( a: AccessKeyLinkInfoApi ): AccessKeyLinkInfo {
    return {
        accessKeyLinkId: a.accessKeyLinkId,
        accessKeyId: a.accessKeyId,
        type: a.type,
        createdWhen: createInstant( a.createdWhen ),
        note: a.note,
        subscription: a.subscription != null ? parseSubscriptionInfo( a.subscription ) : null,
        guest: a.guest != null ? parseSubscriptionParkerAccessKey( a.guest ) : null,
        vehicle: a.vehicle != null ? parseSubscriptionParkerVehicleAccessKey( a.vehicle ) : null,
    }
}

export function parseSubscriptionInfo( s: SubscriptionInfoApi ): SubscriptionInfo {
    return {
        subscriptionId: s.subscriptionId,
        status: s.status,
        start: createLocalDate( s.start ),
        parker: parseParkerInfo( s.parker ),
    }
}

export function parseAccessKeyReq( a: AccessKeyReqApi ): AccessKeyReq {
    return {
        accessKeyNumber: a.accessKeyNumber,
        note: a.note,
    }
}

export function parseAccessKeyAssignSub( a: AccessKeyAssignSubApi ): AccessKeyAssignSub {
    return {
        accessKeyId: a.accessKeyId,
        subscriptionId: a.subscriptionId,
        note: a.note != null ? a.note : null,
    }
}

export function parseAccessKeyParkerAssignReq( a: AccessKeyParkerAssignReqApi ): AccessKeyParkerAssignReq {
    return {
        accessKeyId: a.accessKeyId,
        subscriptionParkerId: a.subscriptionParkerId,
        note: a.note != null ? a.note : null,
    }
}

export function parseAccessKeyVehicleSubAssignReq( a: AccessKeyVehicleSubAssignReqApi ): AccessKeyVehicleSubAssignReq {
    return {
        accessKeyId: a.accessKeyId,
        vehicleSubscriptionId: a.vehicleSubscriptionId,
        note: a.note != null ? a.note : null,
    }
}

export function parseSubscriptionParkerAccessKey( s: SubscriptionParkerAccessKeyApi ): SubscriptionParkerAccessKey {
    return {
        subscription: parseSubscriptionInfo( s.subscription ),
        parker: parseParkerInfo( s.parker ),
    }
}

export function parseSubscriptionParkerVehicleAccessKey( s: SubscriptionParkerVehicleAccessKeyApi ): SubscriptionParkerVehicleAccessKey {
    return {
        isPrimary: s.isPrimary,
        subscription: parseSubscriptionInfo( s.subscription ),
        parker: parseParkerInfo( s.parker ),
        vehicle: parseVehicle( s.vehicle ),
    }
}

export function parseFacilityStats( f: FacilityStatsApi ): FacilityStats {
    return {
        totalMonthlyParkerCount: f.totalMonthlyParkerCount,
        pendingParkers: f.pendingParkers,
        activeReservations: f.activeReservations,
        upcomingReservations: f.upcomingReservations,
        monthlyRecurringRevenue: f.monthlyRecurringRevenue,
        currentMonthTransientRevenue: f.currentMonthTransientRevenue,
        totalUnpaidBalance: f.totalUnpaidBalance,
    }
}

export function parseSubscriptionStat( s: SubscriptionStatApi ): SubscriptionStat {
    return {
        status: s.status,
        start: createLocalDate( s.start ),
        end: s.end != null ? createLocalDate( s.end ) : null,
        qty: s.qty,
        unit: cents( s.unit ),
        total: cents( s.total ),
    }
}

export function parseReservationStat( r: ReservationStatApi ): ReservationStat {
    return {
        start: createInstant( r.start ),
        end: createInstant( r.end ),
        price: cents( r.price ),
    }
}

export function parseOrderStat( o: OrderStatApi ): OrderStat {
    return {
        created: createInstant( o.created ),
        price: cents( o.price ),
        type: o.type,
        isPaid: o.isPaid,
    }
}

export function parseParkerSubInfo( p: ParkerSubInfoApi ): ParkerSubInfo {
    return {
        subscriptionId: p.subscriptionId,
        parkerId: p.parkerId,
        status: p.status,
        quantity: p.quantity,
        unitPrice: cents( p.unitPrice ),
        price: cents( p.price ),
        createdWhen: createInstant( p.createdWhen ),
        guests: p.guests.map( el => parseSubscriptionParker( el ) ),
        plan: parsePlanInfoBasic( p.plan ),
        hasAutoBillingEnabled: p.hasAutoBillingEnabled,
        facilityHasIntegrationsEnabled: p.facilityHasIntegrationsEnabled
    }
}

export function parseFacilityPayment( f: FacilityPaymentApi ): FacilityPayment {
    return {
        paymentId: f.paymentId,
        parentPaymentId: f.parentPaymentId != null ? f.parentPaymentId : null,
        type: f.type,
        amount: cents( f.amount ),
        balance: cents( f.balance ),
        remaining: cents( f.remaining ),
        paymentMethod: f.paymentMethod,
        paymentIntentKey: f.paymentIntentKey != null ? f.paymentIntentKey : null,
        chargeKey: f.chargeKey != null ? f.chargeKey : null,
        createdWhen: createInstant( f.createdWhen ),
        parker: parseParkerInfo( f.parker ),
        changes: f.changes.map( el => parsePaymentChange( el ) ),
        applications: f.applications.map( el => parseApplyPayment( el ) ),
    }
}

export function parseBalanceChange( b: BalanceChangeApi ): BalanceChange {
    return {
        number: b.number,
        type: b.type,
        paidWhen: createInstant( b.paidWhen ),
        payment: b.payment != null ? parsePayment( b.payment ) : null,
        orderBalance: b.orderBalance != null ? parseOrderBalance( b.orderBalance ) : null,
        invoice: b.invoice != null ? parseInvoiceInfo( b.invoice ) : null,
        rank: b.rank,
        balance: cents( b.balance ),
    }
}

export function parseImportPaymentReq( i: ImportPaymentReqApi ): ImportPaymentReq {
    return {
        note: i.note,
        amount: cents( i.amount ),
    }
}

export function parseSession( s: SessionApi ): Session {
    return {
        parker: parseParkerInfo( s.parker ),
        type: s.type,
        subscription: s.subscription != null ? parseSessionSubscription( s.subscription ) : null,
        subscriptionGuest: s.subscriptionGuest != null ? parseSessionSubscription( s.subscriptionGuest ) : null,
        reservation: s.reservation != null ? parseReservation( s.reservation ) : null,
        vehicles: s.vehicles,
    }
}

export function parseSessionSubscription( s: SessionSubscriptionApi ): SessionSubscription {
    return {
        subscriptionId: s.subscriptionId,
        parkerId: s.parkerId,
        status: s.status,
        guests: s.guests.map( el => parseSubscriptionParker( el ) ),
        plan: parsePlanInfoBasic( s.plan ),
        accessPeriods: s.accessPeriods.map( el => parseSessionAccessPeriod( el ) ),
    }
}

export function parseSessionAccessPeriod( s: SessionAccessPeriodApi ): SessionAccessPeriod {
    return {
        subscriptionId: s.subscriptionId,
        parkerId: s.parkerId,
        quantity: s.quantity,
        price: cents( s.price ),
        createdWhen: createInstant( s.createdWhen ),
        guests: s.guests.map( el => parseSubscriptionParker( el ) ),
        plan: parsePlanInfoBasic( s.plan ),
        orderBalance: parseOrderBalance( s.orderBalance ),
    }
}

export function parsePlanInvoiceReq( p: PlanInvoiceReqApi ): PlanInvoiceReq {
    return {
        year: p.year,
        month: p.month,
    }
}

export function parsePlanInvoiceResp( p: PlanInvoiceRespApi ): PlanInvoiceResp {
    return {
        invoice: parseInvoiceInfo( p.invoice ),
        emailArgs: parseInvoiceArgs( p.emailArgs ),
    }
}

export function parseInvoiceInfo( i: InvoiceInfoApi ): InvoiceInfo {
    return {
        invoiceId: i.invoiceId,
        invoiceNumber: i.invoiceNumber,
        orderId: i.orderId,
        createdWhen: createInstant( i.createdWhen ),
        dueWhen: createLocalDate( i.dueWhen ),
        openingBalance: cents( i.openingBalance ),
        amountDue: cents( i.amountDue ),
        endingBalance: cents( i.endingBalance ),
        emailSentWhen: i.emailSentWhen != null ? createInstant( i.emailSentWhen ) : null,
        parker: parseParkerInfo( i.parker ),
    }
}

export function parseInvoiceArgs( i: InvoiceArgsApi ): InvoiceArgs {
    return {
        facilityName: i.facilityName,
        parkerName: i.parkerName,
        invoiceId: i.invoiceId,
        invoiceDate: i.invoiceDate,
        accessPeriodStart: i.accessPeriodStart,
        accessPeriodEnd: i.accessPeriodEnd,
        openingBalance: i.openingBalance,
        orderDesc: i.orderDesc,
        orderPrice: i.orderPrice,
        totalDue: i.totalDue,
        staffName: i.staffName,
        staffEmail: i.staffEmail,
        link: i.link,
        linkText: i.linkText,
        operator: i.operator != null ? parseOperator( i.operator ) : null,
    }
}

export function parseSubscriptionParkerInviteReq( s: SubscriptionParkerInviteReqApi ): SubscriptionParkerInviteReq {
    return {
        subscriptionId: s.subscriptionId,
        quantity: s.quantity,
        name: s.name,
        emailAddress: s.emailAddress,
        isLoginEnabled: s.isLoginEnabled,
        subscriptionGroupId: s.subscriptionGroupId,
        startDate: s.startDate
    }
}

export function parseSubscriptionParkerChangeReq( s: SubscriptionParkerChangeReqApi ): SubscriptionParkerChangeReq {
    return {
        parkerId: s.parkerId,
        quantity: s.quantity,
    }
}

export function parseSubscriptionParkerRemoveReq( s: SubscriptionParkerRemoveReqApi ): SubscriptionParkerRemoveReq {
    return {
        parkerId: s.parkerId,
    }
}

export function parseVehicleAddReq( v: VehicleAddReqApi ): VehicleAddReq {
    return {
        vehicleId: v.vehicleId,
    }
}

export function parseVehicleDeleteReq( v: VehicleDeleteReqApi ): VehicleDeleteReq {
    return {
        vehicleId: v.vehicleId,
    }
}

export function parseVehicleLinkResp( v: VehicleLinkRespApi ): VehicleLinkResp {
    return {
        vehicleLinkId: v.vehicleLinkId,
        vehicleId: v.vehicleId,
        type: v.type,
        subscriptionId: v.subscriptionId,
    }
}

export function parseOrderCustomReq( o: OrderCustomReqApi ): OrderCustomReq {
    return {
        name: o.name,
        emailAddress: o.emailAddress,
        phoneNumber: o.phoneNumber != null ? o.phoneNumber : null,
        description: o.description,
        items: o.items.map( el => parseOrderCustomItemReq( el ) ),
        dueDate: createLocalDate( o.dueDate ),
    }
}

export function parseOrderCustomItemReq( o: OrderCustomItemReqApi ): OrderCustomItemReq {
    return {
        category: o.category != null ? o.category : null,
        name: o.name,
        unitPrice: o.unitPrice,
        quantity: o.quantity,
    }
}

export function parseFacilityPayout( f: FacilityPayoutApi ): FacilityPayout {
    return {
        payoutId: f.payoutId,
        facilityId: f.facilityId,
        payoutKey: f.payoutKey,
        amount: cents( f.amount ),
        createdWhen: createInstant( f.createdWhen ),
        processorCreatedWhen: createInstant( f.processorCreatedWhen ),
        arrivalWhen: createInstant( f.arrivalWhen ),
        transactions: f.transactions.map( el => parsePayoutTransaction( el ) ),
    }
}

export function parsePayoutTransaction( p: PayoutTransactionApi ): PayoutTransaction {
    return {
        payoutTransactionId: p.payoutTransactionId,
        payoutId: p.payoutId,
        balanceTransactionKey: p.balanceTransactionKey,
        type: p.type,
        key: p.key,
        paymentIntentKey: p.paymentIntentKey != null ? p.paymentIntentKey : null,
        chargeKey: p.chargeKey != null ? p.chargeKey : null,
        refundKey: p.refundKey != null ? p.refundKey : null,
        disputeKey: p.disputeKey != null ? p.disputeKey : null,
        payment: p.payment != null ? parsePayoutTransactionPayment( p.payment ) : null,
        gross: cents( p.gross ),
        fee: cents( p.fee ),
        net: cents( p.net ),
        createdWhen: createInstant( p.createdWhen ),
        processorCreatedWhen: createInstant( p.processorCreatedWhen ),
        availableWhen: createInstant( p.availableWhen ),
    }
}

export function parsePayoutTransactionPayment( p: PayoutTransactionPaymentApi ): PayoutTransactionPayment {
    return {
        paymentId: p.paymentId,
        parentPaymentId: p.parentPaymentId != null ? p.parentPaymentId : null,
        type: p.type,
        amount: cents( p.amount ),
        balance: cents( p.balance ),
        createdWhen: createInstant( p.createdWhen ),
        parker: parseParkerInfo( p.parker ),
        applications: p.applications.map( el => parseApplyPayment( el ) ),
    }
}

export function parseOrderAdjustReq( o: OrderAdjustReqApi ): OrderAdjustReq {
    return {
        orderId: o.orderId,
        currentTotalDebt: cents( o.currentTotalDebt ),
        newTotalDebt: cents( o.newTotalDebt ),
        reason: o.reason,
    }
}

export function parsePaymentAdjustReq( p: PaymentAdjustReqApi ): PaymentAdjustReq {
    return {
        paymentId: p.paymentId,
        currentAmount: cents( p.currentAmount ),
        newAmount: cents( p.newAmount ),
        note: p.note,
    }
}

export function parsePlanBillInitResp( p: PlanBillInitRespApi ): PlanBillInitResp {
    return {
        parker: parseParkerInfo( p.parker ),
        order: parseOrderInfo( p.order ),
    }
}

export function parsePlanBillConfirmResp( p: PlanBillConfirmRespApi ): PlanBillConfirmResp {
    return {
        parker: parseParkerInfo( p.parker ),
        order: parseOrderInfo( p.order ),
        success: p.success,
        amountPaid: cents( p.amountPaid ),
        error: p.error,
    }
}


